import { Button, Modal, Toast } from '@seiue/ui'
import { FC, useState } from 'react'
import styled, { css } from 'styled-components'

import { GrowpIcon } from 'packages/components/GrowpIcon'
import {
  CourseOutlineTaskReq,
  Outline,
  courseApi,
} from 'packages/sdks-next/growp'

import { courseOutlineTaskTypeEnumToLabel } from '@/utils/course'

import { EditTask } from '../EditTask'
import { openMoveToOtherChapterModal } from '../MoveToOtherChapter'

/**
 * 任务组件
 *
 * @param param0 - 参数
 * @param param0.task - 任务
 * @param param0.outlineId - 大纲id
 * @param param0.outlines - 大纲列表
 * @returns 任务组件
 */
export const Task: FC<{
  task: CourseOutlineTaskReq
  outlineId?: number
  outlines?: Outline[]
}> = ({ task, outlineId, outlines }) => {
  const [editing, setIsEditing] = useState<boolean>(false)

  const { api: deleteCourseOutlineTask } = courseApi.useDeleteCourseOutlineTask(
    { reload: [courseApi.loadCourseActivityTask] }
  )

  return editing ? (
    <EditTask
      task={task}
      close={() => {
        setIsEditing(false)
      }}
      outlineId={outlineId}
    />
  ) : (
    <TaskWrapper>
      <Left>
        <GrowpIcon
          name="DragVertical"
          className="drag_icon"
        />
        <div className="blank" />
        <LeftLabel>{task.name}</LeftLabel>
      </Left>
      <Right className="task_right_operates">
        <StyleButton
          type="text"
          icon="Switch"
          size="xs"
          onClick={() => {
            if (!task.id) return
            openMoveToOtherChapterModal({
              outlines: outlines || [],
              taskId: task.id,
              defaultOutlineId: outlineId,
            })
          }}
        >
          {'移至其他章节'}
        </StyleButton>
        <StyleButton
          size="xs"
          type="text"
          icon="PenLine"
          onClick={() => {
            setIsEditing(true)
          }}
        >
          {'编辑'}
        </StyleButton>
        <StyleButton
          type="text"
          size="xs"
          icon="Delete"
          onClick={async () => {
            if (task.id && outlineId) {
              Modal.confirm({
                title: '确定要删除此课程任务吗？',
                content: `正在删除课程任务「${task.name}」，课程任务数据将被清空，确认要继续吗？`,
                okText: '确定',
                onOk: async () => {
                  await deleteCourseOutlineTask({
                    id: outlineId,
                    taskId: task.id || 0,
                  })

                  Toast.success('删除成功')
                },
              })
            }
          }}
        >
          {'删除'}
        </StyleButton>
      </Right>
      <RightLabel className="task_right_label">
        {task.type ? courseOutlineTaskTypeEnumToLabel.get(task.type) : '-'}
      </RightLabel>
    </TaskWrapper>
  )
}

const TaskWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  background-color: ${(p) => p.theme.background._4};
  border-bottom: 1px solid ${(p) => p.theme.border.greyNormal};
  border-color: ${(p) => p.theme.border.greyNormal};
  .drag_icon {
    display: none;
  }
  .blank {
    width: 8px;
  }

  &:hover {
    padding-right: 0;
    .drag_icon {
      display: block;
    }
    .task_right_operates {
      display: flex;
    }
    .task_right_label,
    .blank {
      display: none;
    }
  }
`

const Left = styled.div`
  display: flex;
  gap: 8px;
`
const common = css`
  font-size: 14px;
  line-height: 24px;
`

const LeftLabel = styled.div`
  ${common}
  color: ${(p) => p.theme.text._1};
`

const Right = styled.div`
  display: none;
`

const RightLabel = styled.div`
  ${common}
  color: ${(p) => p.theme.text._2};
`
const StyleButton = styled(Button)`
  &&& {
    font-size: 14px;
  }
`
